import React, { useContext } from 'react';
import { Rating } from '@thd-olt-component-react/core-ui';
import { Histogram } from '@thd-olt-component-react/histogram';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ServiceReviewContext } from '../ServiceReviewContext';

const { shape } = proptypes;

export const OverviewRating = ({ reviewData }) => {

  // De-structure reviewData and set default values
  const { aggregation: {
    recommendationCount = 0,
    reviewRatingDistribution = {
      1: 0,
      2: 0,
      4: 0,
      5: 0,
      3: 0
    },
    averageReviewRating = 0
  } = {},
  aggregation = {},
  total = 0,
  reviews = [] } = reviewData;

  const { localStoreZip } = useContext(ExperienceContext);
  const { ctaSection } = useContext(ServiceReviewContext);

  // Map through the aggregation to make data that is required
  // for Histogram component
  const histogram = Object.keys(reviewRatingDistribution).map((key) => ({
    ratingValue: Number(key),
    count: reviewRatingDistribution[key]
  }));

  const hasNoReviews = aggregation === null || reviews.length === 0;
  return (
    <div>
      <div data-testid="ratings" className="sui-flex sui-justify-around sui-text-2xl sui-mx-3 sui-mt-7">

        <div className="sui-flex sui-flex-col sui-h-52">
          <p className="sui-font-bold sui-text-11xl">{hasNoReviews ? 0 : averageReviewRating.toFixed(1)}</p>
          <Rating
            titleEnabled
            value={hasNoReviews ? 0 : averageReviewRating}
          />
          <p>{hasNoReviews ? 'no reviews' : (<span>out of {total} <br /> reviews</span>)}</p>
        </div>
        <div className="sui-w-7/12" data-testid="histogram">
          <Histogram ratings={histogram} />
        </div>

      </div>
      {!hasNoReviews && (
        <div className="sui-flex sui-justify-center sui-mt-3">
          <p>
            <span className="sui-font-bold">
              {
                ((recommendationCount / total) * 100).toFixed(0)
              }%
            </span>
            of customers recommend this service
          </p>
        </div>
      )}
      <div className="sui-flex sui-items-center sui-justify-center sui-mt-3">
        {ctaSection}
      </div>
      <div className="sui-font-bold sui-flex sui-justify-between sui-items-center sui-bg-strong sui-h-14 sui-mt-8">
        <p className="sui-ml-5">
          {hasNoReviews ? '0 reviews' : `1-${reviews.length} of ${total} verified reviews`}
        </p>
        <p className="sui-mr-5">
          Looks like you&apos;re in:
          <span className="sui-text-info">
            {localStoreZip}
          </span>
        </p>
      </div>
    </div>
  );
};

OverviewRating.displayName = 'OverviewRating';
OverviewRating.propTypes = {
  reviewData: shape({}).isRequired
};
